import { clone } from "lodash";
import { sitesPipelineStore } from "../store";

type UpdateRowHeightsAcrossStageArgs = {
  sourceStageId: string;
  toIndex: number;
  fromIndex: number;
  targetStageId: string;
};

export function updateRowHeightsBetweenStages({
  targetStageId,
  toIndex,
  fromIndex,
  sourceStageId,
}: UpdateRowHeightsAcrossStageArgs) {
  const sourceRowHeights = clone(sitesPipelineStore.getRowHeightsByStageId?.[sourceStageId]?.());
  const targetRowHeights = clone(sitesPipelineStore.getRowHeightsByStageId?.[targetStageId]?.());

  if (!sourceRowHeights || !targetRowHeights) return;

  const [movingRowHeight] = sourceRowHeights.splice(fromIndex, 1);
  targetRowHeights.splice(toIndex, 0, movingRowHeight);

  sitesPipelineStore.setRowHeightsByStageId?.[sourceStageId]?.(sourceRowHeights);
  sitesPipelineStore.setRowHeightsByStageId?.[targetStageId]?.(targetRowHeights);
}
